<template>
  <VisionSidebar
    :visible="visible"
    title="Select your Location"
    @close="close"
  >
    <VisionLoadingSpinner :loading="loading" />

    <div :class="$b('body')">
      <div :class="$b('country')">
        <ClientOnly>
          <CountrySelect
            :featured-country-codes="featuredCountryCodes"
            @country-changed="newCountryCode = $event"
          />
          <template #fallback>
            <div
              class="vision-shimmer vision-shimmer--rounded"
              :style="{ width: '100%', height: '56px' }"
            />
          </template>
        </ClientOnly>
      </div>

      <div :class="$b('buttons')">
        <VisionButton
          button-text="Submit"
          background-colour="gradient"
          @click="submit"
        />

        <VisionLink
          is-button
          line-link
          size="small"
          @click="close"
        >
          Cancel
        </VisionLink>
      </div>
    </div>
  </VisionSidebar>
</template>

<script>
import { FEATURED_COUNTRY_CODES } from 'assets/js/featured-countries'

export default {
  name: 'LocalisationSidebar',

  props: {
    visible: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  setup(props) {
    const sidebarStore = useSidebarStore()
    const pageStore = usePageStore()

    if (props.visible) pageStore.toggleBlockBodyScroll(true)

    return { sidebarStore, pageStore }
  },

  data: () => ({
    newCountryCode: '',
    loading: false,
    featuredCountryCodes: FEATURED_COUNTRY_CODES,
  }),

  watch: {
    visible(visible) {
      this.pageStore.toggleBlockBodyScroll(visible)
    },
  },

  beforeUnmount() {
    this.pageStore.toggleBlockBodyScroll(false)
  },

  methods: {
    close() {
      this.sidebarStore.toggleCountrySelector()
    },

    submit() {
      if (!this.newCountryCode) return

      const url = new URL(window.location.href)

      // Replace the current locale with the new one
      url.pathname = url.pathname.replace(
        `/${this.$i18n.locale.value}/`,
        `/${this.newCountryCode}/`
      )

      // Add country query parameter to update locale redirecter
      url.searchParams.set('country', this.newCountryCode.split('-')[1])

      // Ensure we don't reload the page if the URL is the same
      if (url.href === window.location.href) return this.close()

      window.location.href = url.href
    },
  },
}
</script>

<style lang="postcss">
.LocalisationSidebar__body {
  @apply px-4 space-y-sm;
}

.LocalisationSidebar__buttons {
  @apply flex items-center space-x-xxs;
}
</style>
